<template>
  <a-modal
    ref="modalRef"
    v-model:visible="show"
    :width="600"
    :footer="null"
    :after-closed="onClosed"
    wrap-class-name="_record_popup"
  >
    <template #title>
      <div class="w-full">动态预览图</div>
    </template>
    <div class="bg-yellow-510 h-full w-full bg-black-card py-6 pt-2">
      <div class="text-center opacity-70">动态预览图用于上传至表盘市场！</div>
      <div
        class="box-content flex items-center justify-center mt-4"
        :style="{
          borderRadius: watchfaceRaduis
        }"
      >
        <canvas
          ref="canvasRef"
          :width="watchfaceStore.size.width"
          :height="watchfaceStore.size.height"
          :style="{
            borderRadius: 'inherit',
            boxSizing: 'content-box'
          }"
        />
      </div>
      <div class="mt-4 flex items-center justify-center gap-2">
        <a-button :loading="exporting" @click="onPlay">预览</a-button>
        <a-button :loading="exporting" @click="onExport">导出</a-button>
        <a-button @click="onClose">关闭</a-button>
      </div>
      <div v-if="status != 'done'" class="text-center mt-2 opacity-70">
        <span v-if="status == 'ffmpegDownloading'"> 基础文件下载中... </span>
        <span v-if="status == 'recording'"> 动画录制中... </span>
        <span v-if="status == 'toWebping'"> 动图导出中... </span>
      </div>
    </div>
  </a-modal>

  <a-modal v-model:visible="showSuccess" title="导出成功">
    <div class="flex items-center justify-center flex-col">
      <icon :icon="'Vector.svg'" :width="48" :height="48" fill="none" />
      <span class="mt-2 text-base">已生成动图文件，可将其上传至表盘市场！</span>
      <span
        class="mt-2 opacity-70 text-center w-2/3 hover:underline hover:cursor-pointer"
        @click="showWebp"
        >{{ webpFile }}</span
      >
    </div>

    <template #footer>
      <a-button key="back" @click="() => (showSuccess = false)">关闭</a-button>
      <a-button type="primary" @click="showWebp"> 查看动图 </a-button>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { getWatchfaceDeviceRadius } from '@/hooks';
import { useWatchfaceAnimation } from '@/hooks/use-watchface-animation';
import { ElectronApi } from '@/services/electron.api';
import { WatchfaceService } from '@/services/watchface';
import { useEditorStore } from '@/store/use-editor-store';
import { useWatchfaceStore } from '@/store/use-watchface-store';
import { Modal } from 'ant-design-vue';
import { computed, nextTick, ref } from 'vue';

const editorStore = useEditorStore();

const show = ref(false);
const watchfaceStore = useWatchfaceStore();

const canvasRef = ref();
const { playAnimation, exportWebp, status, initCanvas, renderer } =
  useWatchfaceAnimation(canvasRef);

defineExpose({
  async open() {
    show.value = true;
    await nextTick();
    if (editorStore.theme)
      initCanvas(editorStore.theme, editorStore.themeColor);
  }
});

const onClose = () => {
  show.value = false;
};
const onClosed = () => {
  renderer?.cleanCanvas();
  renderer?.runtime.clear();
  show.value = false;
};

const exporting = ref(false);
const onExport = async () => {
  try {
    exporting.value = true;
    const { path } = ElectronApi;
    const _root = new WatchfaceService().Path;
    const to = path?.join(_root, 'animation.webp');
    const webp = await exportWebp(to);
    if (!webp) throw '导出失败';
    if (show.value) showSuccess.value = true;
    webpFile.value = webp;
  } catch (error) {
    webpFile.value = '';
    Modal.warning({
      title: '导出失败，请重试',
      zIndex: 1000
    });
  } finally {
    exporting.value = false;
  }
};

const scale = ref(1);
const watchfaceRaduis = computed(() => {
  return (
    getWatchfaceDeviceRadius(watchfaceStore.deviceType ?? '') * scale.value +
    'px'
  );
});

const onPlay = async () => {
  playAnimation();
};

// 动图导出成功
const showSuccess = ref(false);
const webpFile = ref('');
const showWebp = () => {
  ElectronApi.showItemInFolder(webpFile.value);
};
</script>

<style lang="less">
._record_popup {
  .ant-modal-body {
    background: rgb(74, 74, 74);
    padding: 0 !important ;
  }
}
</style>
